import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { ListSpacesParams } from '~/shared/space/space-list.params'
import { getSpacesFromTypesense } from '~/client/space/space-list.api'
import { getSpacesFromTypesenseVibeSearch } from '~/client/space/space-vibe-search.api'

export const useSpaces = (params: ListSpacesParams, options?: { enabled?: boolean }) => {
  const enabled = options?.enabled ?? true
  const {
    data: spacesData,
    isLoading,
    error,
    isFetching,
    isPlaceholderData,
  } = useQuery({
    queryKey: ['spaces', params],
    queryFn: async ({ signal }) => {
      let result
      if (params.vibe_search) {
        result = await getSpacesFromTypesenseVibeSearch(params, { signal })
      } else {
        result = await getSpacesFromTypesense(params, { signal })
      }
      return result
    },
    placeholderData: keepPreviousData,
    staleTime: 30_000,
    enabled,
  })

  const isFetchingPage = !!isFetching && !!isPlaceholderData

  return {
    data: spacesData?.data,
    count: spacesData?.count,
    isLoading,
    isFetching,
    isFetchingPage,
    isLoadingAttachments: false,
    error,
  } as const
}
